export const WEEKS_BEFORE = 4;
export const WEEKS_TOTAL = 12;
